import * as Sentry from '@sentry/gatsby'

import { beforeSend, ignoreErrors } from './src/utils/sentry'

// This global name is fixed by @sentry/gatsby's Webpack DefinePlugin.
// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle
declare const __SENTRY_RELEASE__: string | undefined

const environment = process.env.GATSBY_ENV || 'development'

Sentry.init({
  dsn: 'https://403987968d0541b7b65b6ac76038f66a@o925641.ingest.sentry.io/5961720',
  environment,
  release: __SENTRY_RELEASE__,
  // Only send events in production so local and staging traffic do not create noise.
  sampleRate: environment === 'production' ? 1 : 0,
  beforeSend,
  ignoreErrors,
})
